type Category = {
  childCategoryIds: string[];
  name: string;
  parentCategoryId?: string;
  translations?: Record<string, Record<string, string>>;
};

type CategoryVisibility = 'VISIBLE' | 'HIDDEN_UNPUBLISHED' | (string & {});

type CategoryVerdict =
  | 'ALIGNED'
  | 'DRIFTED'
  | 'NOT_EVALUATED'
  | 'REPURPOSED'
  | (string & {});

type MarketCategoryStatus = {
  activeCategories: string[];
  inactiveCategories: string[];
  visibility?: Record<string, CategoryVisibility>;
  verdicts?: Record<string, CategoryVerdict>;
};

type CategoriesData = Record<string, Category>;

type MarketCategoryStatusData = Record<string, MarketCategoryStatus>;

type MappedCategory = Category & {
  categoryId: string;
};

type MappedMarketCategoryStatus = MarketCategoryStatus & {
  marketId: string;
  name?: string;
};

type dashboardData = {
  categories: CategoriesData;
  markets: MarketCategoryStatusData;
};

const shopCategoriesData = (data: dashboardData): MappedCategory[] => {
  return data?.categories
    ? Object.entries(data.categories as CategoriesData).map(
        ([categoryId, categoryData]) => ({
          categoryId,
          ...categoryData,
        }),
      )
    : [];
};

const shopMarketsData = (
  data: dashboardData,
  marketsFromApi?: Record<string, { countryName?: string }>,
): MappedMarketCategoryStatus[] => {
  return data?.markets
    ? Object.entries(data.markets as MarketCategoryStatusData).map(
        ([marketId, marketData]) => ({
          marketId,
          name: marketsFromApi?.[marketId]?.countryName,
          ...marketData,
        }),
      )
    : [];
};

const mapShopDashboardData = (
  data: dashboardData,
  marketsFromApi?: Record<string, { countryName?: string }>,
) => {
  const categories = shopCategoriesData(data);
  const markets = shopMarketsData(data, marketsFromApi);

  return {
    ...data,
    categories,
    markets,
  };
};

export default mapShopDashboardData;
export type {
  Category,
  CategoryVerdict,
  CategoryVisibility,
  CategoriesData,
  MappedCategory,
  MarketCategoryStatus,
  MarketCategoryStatusData,
  MappedMarketCategoryStatus,
};
